import { validarCpf, limparCpf } from './validarCpf'

function parseDataBr(str) {
  if (!str || typeof str !== 'string') return null
  const s = str.trim()
  if (!s) return null
  const match = s.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/)
  if (match) {
    const d = parseInt(match[1], 10)
    const m = parseInt(match[2], 10) - 1
    const y = parseInt(match[3], 10)
    const year = y < 100 ? 2000 + y : y
    const date = new Date(year, m, d)
    if (!isNaN(date.getTime())) return date.toISOString().slice(0, 10)
  }
  if (/^\d{8}$/.test(s)) {
    const d = parseInt(s.slice(0, 2), 10)
    const m = parseInt(s.slice(2, 4), 10) - 1
    const y = parseInt(s.slice(4, 8), 10)
    const date = new Date(y, m, d)
    if (!isNaN(date.getTime())) return date.toISOString().slice(0, 10)
  }
  return null
}

function parseLinha(linha, separador = ',') {
  const colunas = []
  let atual = ''
  let entreAspas = false
  for (let i = 0; i < linha.length; i++) {
    const c = linha[i]
    if (c === '"') entreAspas = !entreAspas
    else if ((c === separador || c === ';') && !entreAspas) {
      colunas.push(atual.trim())
      atual = ''
    } else atual += c
  }
  colunas.push(atual.trim())
  return colunas
}

export function parseCsvLeads(text, separator = ',') {
  const linhas = text.split(/\r?\n/).filter((l) => l.trim())
  const resultados = { validos: [], invalidos: [] }

  for (let i = 0; i < linhas.length; i++) {
    const colunas = parseLinha(linhas[i], separator)
    const cpfRaw = (colunas[0] || '').trim()
    const cpf = limparCpf(cpfRaw)
    const nome = (colunas[1] || '').trim()
    const dataNasc = parseDataBr(colunas[2])
    const telefone = (colunas[3] || '').trim().replace(/\D/g, '').slice(0, 20) || null

    const item = { cpf, cpfFormatado: cpfRaw, nome, data_nascimento: dataNasc, telefone, linha: i + 1 }

    if (!cpf || cpf.length !== 11) {
      item.motivo = 'CPF inválido ou incompleto'
      resultados.invalidos.push(item)
      continue
    }

    if (!validarCpf(cpf)) {
      item.motivo = 'CPF com dígitos inválidos'
      resultados.invalidos.push(item)
      continue
    }

    if (!nome || nome.length < 2) {
      item.motivo = 'Nome obrigatório'
      resultados.invalidos.push(item)
      continue
    }

    resultados.validos.push(item)
  }

  return resultados
}
